import FooterHero from '../../component/common/CTA'
import HowWeHelp from '../../component/common/howWeHelp'
import CaseStudySlider from '../../component/common/caseStudy'
import { Helmet } from 'react-helmet-async';
import Banner from '../../component/common/Banner';
import CirclePoints from '../../component/common/circlePoints';
import { FaCheck } from 'react-icons/fa';
import { RiCloseLargeFill } from 'react-icons/ri';
import { IoWarning } from 'react-icons/io5';
import HowItWorksSection from '../../component/indian/howItWorks';
import WhatWeGetSection from '../../component/indian/whatWeGet';

const caseStudiesData = [
  {
    image: "img/logos/bid-your-stay.png",
    heading: {bold : "BidYourStay" , light : '– B2C TravelTech Platform'},
    content : [
      {title : 'Challenge' , description : 'A team of seasoned founders had a vision to let users bid for unsold hotel rooms, but no tech team or GTM expertise.'},
      {title : 'TurningIdeas Role' , description : 'A team of seasoned founders had a vision to let users bid for unsold hotel rooms, but no tech team or GTM expertise.'},
      {title : 'Outcome' , description : 'Within 6 weeks, BidYourStay ran paid campaigns, landed its first 10 hotel demos, and pitched to early-stage VCs with traction in hand.'}
    ]
  },
  {
    image: "img/logos/intellidb.png",
    heading: {bold : "IntelliDB" , light : '– Global first Postgres AI-Driven Database'},
    content : [
      {title : 'Challenge' , description : 'The founders needed to validate product-market fit before fundraising, but lacked UX and GTM bandwidth.'},
      {title : 'TurningIdeas Role' , description : 'We helped with GTM and market message strategy, redesigned onboarding flows, created demo use cases, and opened GTM discussions with enterprise customers.'},
      {title : 'Outcome' , description : 'Within 60 days, the product had paying pilot users, a compelling investor deck, and received inbound interest from strategic angels and closed a fundraise.'}
    ]
  },
];

const heroData = {
  title: {
    bold: "Indian",
    light: "Startups",
  },
  subtitle: "Accelerate Growth Across Asia",
  description: {
    heading: "Scale Your Startup Beyond India",
    intro: "Indian startups have immense potential to grow, but",
    outro: "often slow them down. We help you accelerate growth with a structured approach."
  },
  highlightedText: "funding, sales, and execution challenges",
  heroImage: "img/indian-hero.png",
  bgImg: "img/indian-hero-bg.png",
  btnText: "Accelerate Growth",
  btnLink: "https://forms.gle/F1AhEsmWPnMmpXGM7"
};

const serviceCards = [
  {
    title: "Product Market Fit Validation",
    text: "Ensuring your product is ready to scale.",
    subtext: "",
    iconLink: "img/indian-help1.png" // Target icon
  },
  {
    title: "Investor & Funding Support",
    text: "Connecting you with VCs & angel investors.",
    subtext: "",
    iconLink: "img/indian-help2.png" // Money icon
  },
  {
    title: "Sales & GTM Acceleration",
    text: "Helping you close enterprise deals faster.",
    subtext: "",
    iconLink: "img/indian-help3.png" // Growth chart icon
  },
  {
    title: "Operational Scale-Up",
    text: "Optimizing your business for rapid expansion.",
    subtext: "",
    iconLink: "img/indian-help4.png" // Rocket icon
  }
];

const statsDataHeading = {
  light: "Why work with",
  bold: "us?"
}

const statsData = [
  {
    title: "$142 Million+",
    text: "raised by our clients"
  },
  {
    title: "11",
    text: "Enterprise Secured"
  },
  {
    title: "164",
    text: "Startups Mentored"
  }
];

const worldMapImg = "img/why-indian.png";


const headerData = {
  title: "What You Get",
  highlightedText: "Indian Startups Scale",
  description: "From Idea  to Exit, Together, When we partner with Founders, We’re all in combining Expertise, Empathy, Embedded Resources and Capital to build breakout companies",
  imgLink: "img/help-indian.png"
};

const BANNER_CONTENT = [{ subHeading : 'Tired of MVP delays, GTM confusion, or Investor Rejections?' , description : 'We are a venture studio that partners with startup teams to build, validate, and scale innovative ideas in India and Asia.' , url : 'https://forms.gle/F1AhEsmWPnMmpXGM7' , linkText: 'Apply Now'}]

const PAIN_POINTS = [
  { img : 'img/pain-point-1.png' , figCaption : 'No Tech Team to Build MVP' , description : 'No Tech Team to Build MVP'},
  {img : 'img/pain-point-2.png' , figCaption : 'No Clarity on Go-To-Market' , description : 'We launch and run your GTM'},
  {img : 'img/pain-point-3.png' , figCaption : 'Can’t Afford Full Time Hires' , description : 'We get you investor-ready'},
  {img : 'img/pain-point-4.png' , figCaption : 'Struggling to Raise Funds' , description : 'We invest our sweat as your first investors'},
]

const HOW_IT_WORKS = [
  {img : 'img/how-it-works-1.png' , heading : 'Apply' , description : 'Tell us about what are you trying to solve'},
  {img : 'img/how-it-works-2.png' , heading : 'Scoping Call' , description : 'Align on your idea, blockers, and growth plan (Week 1)'},
  {img : 'img/how-it-works-3.png' , heading : 'Build & Launch' , description : 'MVP or GTM ready in 4–6 weeks'},
  {img : 'img/how-it-works-4.png' , heading : 'Scale & Raise' , description : 'Introductions to customers/investors post-traction'},
]

const IndiaPage = () => {
  return (
    <div>

      <Helmet>
        <title>Accelerate Your Startup Growth with TurningIdeas</title>
        <meta name="description" content="Indian startups can scale faster with TurningIdeas’ co-building model – get MVP support, GTM execution, sales growth, and investor access." />
        <meta name="keywords" content="scale Indian startup, startup growth India, MVP support India, startup fundraising help" />
      </Helmet>

      <Banner content={BANNER_CONTENT} img='img/Banner/Indian.png' />

      <CirclePoints heading='Founder Pain Points We Solve' points={PAIN_POINTS} className='grid min-[607px]:grid-cols-2 min-[847px]:grid-cols-4 gap-y-10' />

      <section className="container max-w-7xl mx-auto px-6 md:px-12">
        <HowWeHelp
          headerData={headerData}
          serviceCards={serviceCards}
          statsDataHeading={statsDataHeading}
          statsData={statsData}
          worldMapImg={worldMapImg}
        />
      </section>

      <HowItWorksSection />

      {/* FEATURES */}
      <section className='container max-w-7xl mx-auto px-6 md:px-12 my-36'>
          <h2 className='text-[#111827] text-center font-[600] leading-[40px] text-[34px] sm:text-[40px] mt-6 mb-7'>
              How are we different
          </h2>
          <div className='grid grid-cols-[max-content_1fr_1fr_1fr] max-[813px]:overflow-x-auto min-[813px]:grid-cols-4 bg-[#C8F2FF] p-6 rounded-[15px]'>
            <div className=''>
              <h5 className='border-b-[4px] border-[#82E2FF] font-[500] max-[813px]:text-center text-[20px] md:text-[25px] py-9 px-3 min-[876px]:px-5 min-[963px]:px-8'>Feature</h5>
              <ol>
                <li className='border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] max-[813px]:text-center text-[18px] py-8 px-3 min-[876px]:px-5 min-[963px]:px-8'>Builds MVP</li>
                <li className='border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] max-[813px]:text-center text-[18px] py-8 px-3 min-[876px]:px-5 min-[963px]:px-8'>Runs GTM</li>
                <li className='border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] max-[813px]:text-center text-[18px] py-8 px-3 min-[876px]:px-5 min-[963px]:px-8'>Co-Build Model</li>
                <li className='border-b-[4px] border-transparent font-[500] text-[#000000] max-[813px]:text-center text-[18px] py-8 px-3 min-[876px]:px-5 min-[963px]:px-8'>Takes Equity</li>
              </ol>
            </div>
            <div className=''>
              <h5 className='text-center border-b-[4px] border-[#82E2FF] font-[500] text-[20px] md:text-[25px] py-9 px-3 min-[876px]:px-5 min-[963px]:px-8'>TurningIdeas</h5>
              <ol>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-green-600 flex items-center justify-center'><FaCheck className='text-[#ddf3fa] text-xl md:text-xl' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-green-600 flex items-center justify-center'><FaCheck className='text-[#ddf3fa] text-xl md:text-xl' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-green-600 flex items-center justify-center'><FaCheck className='text-[#ddf3fa] text-xl md:text-xl' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-transparent font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-green-600 flex items-center justify-center'><FaCheck className='text-[#ddf3fa] text-xl md:text-xl' /></span>
                </li>
              </ol>
            </div>
            <div className=''>
              <h5 className='text-center border-b-[4px] border-[#82E2FF] font-[500] text-[20px] md:text-[25px] py-9 px-3 min-[876px]:px-5 min-[963px]:px-8'>VC</h5>
              <ol>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-red-600 flex items-center justify-center'><RiCloseLargeFill className='text-[#ddf3fa] stroke-[2px] text-lg' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-red-600 flex items-center justify-center'><RiCloseLargeFill className='text-[#ddf3fa] stroke-[2px] text-lg' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-red-600 flex items-center justify-center'><RiCloseLargeFill className='text-[#ddf3fa] stroke-[2px] text-lg' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-transparent font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-green-600 flex items-center justify-center'><FaCheck className='text-[#ddf3fa] text-xl' /></span>
                </li>
              </ol>
            </div>
            <div className=''>
              <h5 className='text-center border-b-[4px] border-[#82E2FF] font-[500] text-[20px] md:text-[25px] py-9 px-3 min-[876px]:px-5 min-[963px]:px-8'>Accelerator</h5>
              <ol>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-red-600 flex items-center justify-center'><RiCloseLargeFill className='text-[#ddf3fa] stroke-[2px] text-lg' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full flex items-center justify-center'><IoWarning className='text-yellow-500 text-6xl' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-[#82E2FF] font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full flex items-center justify-center'><IoWarning className='text-yellow-500 text-6xl' /></span>
                </li>
                <li className='flex items-center justify-center border-b-[4px] border-transparent font-[500] text-[#000000] text-[18px] py-[29.5px] px-3 min-[876px]:px-5 min-[963px]:px-8'>
                  <span className='w-8 h-8 rounded-full bg-green-600 flex items-center justify-center'><FaCheck className='text-[#ddf3fa] text-xl' /></span>
                </li>
              </ol>
            </div>
          </div>
      </section>
      {/* FEATURES */}

      <WhatWeGetSection />

      <section className="py-6 md:py-12 bg-black">
        <div className="container max-w-7xl mx-auto px-6 md:px-12">
          <CaseStudySlider caseStudies={caseStudiesData} />
        </div>
      </section>

      <FooterHero
        heading="Want a Partner to Co-Build"
        paragraph="Whether you're a Startup, Investor or Enterprise, We help you Scale, Innovate and Succeed."
        buttonText="Contact Us Today!"
      />
    </div>
  );
};

export default IndiaPage;
